<div class="clinician-index-hero" [class.pb-16]="(consultationPopup.shouldShowPopup$ | async)">

  <div class="w-full flex flex-col">
    <app-header></app-header>
  </div>
  <div class="flex flex-row h-full w-full overflow-hidden min-h-0">
    <app-sidebar [sidebarItems]="sidebarItems"></app-sidebar>
    <router-outlet></router-outlet>
    <div class="absolute bottom-0 left-0 right-0">
      <app-appointment-ribbon></app-appointment-ribbon>
    </div>
  </div>
</div>
